import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { BaseRoutes } from '@nts/std';
import { environment } from 'src/environments/environment';
const title = environment ? environment.appTitle : 'Application Title';

const routes: Routes = [

  // #region rotte con autenticazione
  ...BaseRoutes.getBaseAuthentictedRoutes(
    environment,
    [
      ...BaseRoutes.getEntityRoutes(
        title,
        'layoutdefinition',
        () => import('./layout-definition/layout-definition.module').then(m => m.LayoutDefinitionModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'layoutselection',
        () => import('./layout-selection/layout-selection.module').then(m => m.LayoutSelectionModule)
      ),
      ...BaseRoutes.getEntityRoutes(
        title,
        'configurationsettings',
        () => import('./configuration-settings/configuration-settings.module').then(m => m.ConfigurationSettingsModule)
      ),
      ...BaseRoutes.getDefaultRoutes(
        title,
        environment,
        true
      ),
      {
        path: 'manage/userlayoutdata',
        loadChildren: () => import('./user-layout-data/user-layout-data.module').then(mod => mod.UserLayoutDataModule),
        data: {
          title: environment.appTitle
        }
      },
    ]
  ),
  // #endregion rotte con autenticazione

  // rotte base per la gestione degli errori
  ...BaseRoutes.getBaseErrorsRoute()
];

@NgModule({
  imports: [
    // TODO Tommy: si potrebbe creare una custom preloadin strategy per precaricare solo le rotte offline
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', paramsInheritanceStrategy: 'always', preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
